export default "__VITE_ASSET__rLoO1hs___"